import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import Translate from '../translate/Translate';
import {TimeoutDialogController} from './TimeoutDialog.controller';
import {GenericModal} from '@techsee/techsee-ui-common/lib/modals/generic';
import './TimeoutDialog.style.scss';

export interface TimeoutDialogProps {
    ctrl: TimeoutDialogController;
}

const TimeoutDialogHeader = observer(({ctrl}: TimeoutDialogProps): JSX.Element => {
    return (
        <div className='timeout-dialog-header' dir={ctrl.dir}>
            <h3 className='timeout-dialog-title'>
                <Translate text='TIMEOUT.VIEW.TITLE' />
            </h3>
        </div>
    );
});

const TimeoutDialogBody = observer(({ctrl}: TimeoutDialogProps): JSX.Element => {
    return (
        <div className='timeout-dialog-body' dir={ctrl.dir}>
            <p>
                <Translate text='TIMEOUT.VIEW.BODY' translateValues={{timer: ctrl.timer}} />
            </p>
        </div>
    );
});

const TimeoutDialogFooter = observer(({ctrl}: TimeoutDialogProps): JSX.Element => {
    return (
        <div className='timeout-dialog-footer' dir={ctrl.dir}>
            <button className='btn btn-primary' type='button' onClick={() => ctrl.keepAlive('yes')}>
                <Translate text='TIMEOUT.VIEW.KEEP_ROOM' />
            </button>
            <button className='btn btn-warning' type='button' onClick={() => ctrl.keepAlive('no')}>
                <Translate text='TIMEOUT.VIEW.END_NOW' />
            </button>
        </div>
    );
});

@observer
export class TimeoutDialog extends TechseeBaseComponent<TimeoutDialogProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        if (!ctrl) {
            return <div />;
        }

        const modalClassName = 'modal-dialog timeout-dialog custom-timeout-styles';

        return (
            <GenericModal
                className={modalClassName}
                header={() => <TimeoutDialogHeader ctrl={ctrl} />}
                content={() => <TimeoutDialogBody ctrl={ctrl} />}
                toolbar={() => <TimeoutDialogFooter ctrl={ctrl} />}
                onHideHandler={() => ctrl.hide()}
                show={ctrl.isVisible}
            />
        );
    }
}
